<script>
	import ProductPlanBillingCycle from '@/enums/productPlanBillingCycle';

	export default {
		name: 'ProductPlanDetailsTitleAndPrice',
		props: {
			productPlan: {
				type: Object,
				required: true
			},
			pricingOptionId: {
				type: String,
				required: true
			}
		},
		computed: {
			pricingOption() {
				return this.productPlan.pricingOptions.find(x => x.id === this.pricingOptionId)
			}
		},
		methods: {
			getPlanCycleTime(billingCycle) {
				switch (billingCycle) {
					case ProductPlanBillingCycle.Monthly: return "month"
					case ProductPlanBillingCycle.Annual: return "year"
				}
			}
		}
	};
</script>

<template>
	<div class="full text-xs-center">
		<div class="title-description">
			<div class="headline">{{ productPlan.name }}</div>
			<span class="subheading text--secondary">{{ productPlan.description }}</span>
		</div>
		<div class="mt-4 price-container">
			<h2 class="display-1 font-weight-bold">${{ pricingOption.unitAmount }}</h2>
			<span class="caption">per employee / {{getPlanCycleTime(pricingOption.billingCycle)}}</span>
		</div>
	</div>
</template>

<style scoped>
.price-container {
    text-align: center;
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1.5rem;
}

</style>